module.exports = __webpack_public_path__ + "images/getbikeservice_smallb14bcfb9bbb0ebb22d48ef17fa260caa.png";